import { getSalesExecutiveCode } from 'utils/auth/authHelper';
import { plansIcon, plansIconHighlight } from 'mocks/plans';

export const baseUrl = '/plans';

export const buildScholarshipURL = (plan) =>
  `/scholarships/${plan?.identifier}?code=${plan?.code}`;

export const buildPlanURL = (plan, router) => {
  const isTrial = plan?.trial?.code && `&code=${plan?.trial?.code}`;
  const isCorporate =
    router?.asPath?.includes('/corporate') && `&corporate=${router?.query?.id}`;
  const queryParams = buildQueryParams(isTrial, isCorporate);

  return `/subscription?plan=${plan?.identifier}${queryParams}`;
};

export const buildQueryParams = (...args) =>
  args
    .filter(Boolean)
    .reduce((acc, curr) => acc + curr, '')
    .split(',')
    .join('');

export const handleSuccessButton = () => {
  if (document) {
    const target = document.querySelector('#plans');

    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
};

export const showPrices = (user) => {
  if (user) {
    return getSalesExecutiveCode(user);
  }

  return false;
};

// We created a method specific on mobile, and we did not see the need to make it dynamic through the backend.
export const contractionNamePlans = (planName) => {
  let newPlanName = planName;

  if (planName.toLowerCase().includes('professional'))
    newPlanName = planName.toLowerCase().replace('professional', 'pro');

  if (planName.toLowerCase().includes('online'))
    newPlanName = planName.toLowerCase().replace('online plus', 'online');

  return newPlanName;
};

export const getIconByType = (type, isHighlight = false) =>
  isHighlight ? plansIconHighlight[type] : plansIcon[type];

export const getIconByTypeHighlighted = (type) => plansIconHighlight[type];

export const filterRecurrencesByFrequencyAndPaymentType = (
  plan,
  targetFrequency = 'anual',
  targetPaymentType = 'creditCard'
) => {
  if (!plan || !plan.recurrencies) {
    return {}; // Return an empty object if plan or recurrencies is not defined
  }

  return plan.recurrencies.filter(
    (r) =>
      r.frequency === targetFrequency && r.paymentType === targetPaymentType
  )[0];
};

export const generateReviewSchema = () => {
  const reviewSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Assinatura - Fluencypass',
    image:
      'https://res.cloudinary.com/intercambiodireto-com/f_auto,c_limit,w_384,q_50/fluency_pass_logotipo.png',
    description:
      'A maior plataforma online de intercâmbio. Compare agora mesmo centenas de países, cidades e escolas no exterior, com até 40% off, sem taxa de agência e até 12x para pagar. Suporte e assessoria grátis.',
    brand: {
      '@type': 'Brand',
      name: 'Fluencypass',
    },
    gtin8: 'BR',
    currenciesAccepted: 'BRL',
    paymentAccepted: 'Crédito, Débito, Dinheiro, Boleto e Transferência',
    areaServed: 'BR',
    award:
      'O ciclo completo da fluência: Aulas 24h, conversação, aula particular e intercâmbio no final.',
    sku: 'assinatura',
    aggregateRating: {
      '@type': 'AggregateRating',
      bestRating: '5',
      worstRating: '1',
      ratingValue: '4.6',
      ratingCount: '497',
    },
    review: {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Fluencypass',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Google',
      },
    },
    itemReviewed: {
      '@type': 'Course',
      name: 'Course',
    },
  };

  return JSON.stringify(reviewSchema);
};

export const silentlyUpdateBlur = () => {
  const hiddenInputElement = document.getElementById('hidden-blur-update');

  if (hiddenInputElement) {
    hiddenInputElement.click();
  }
};
